/**
 * Custom variant options: encourage Special Instructions / uploads (no cart block).
 * Hides accelerated checkout for custom selections and quote-tagged products (per section only).
 */
(function () {
  'use strict';

  var CUSTOM_RE = /\bcustom\b/i;

  var checkoutSelectors = [
    'shopify-accelerated-checkout',
    '.accelerated-checkout-block',
    '.shopify-payment-button',
    '.additional-checkout-buttons',
    'more-payment-options-link',
    '[data-ctc-accelerated-wrap]',
    '.wallet-buttons',
    '.dynamic-checkout__content',
  ].join(', ');

  function isOptOutCustomValue(value) {
    var v = String(value || '')
      .trim()
      .toLowerCase();
    if (!v) return false;
    if (v === 'no' || v === 'none' || v === 'n/a' || v === 'na' || v === 'false' || v === 'off') return true;
    if (v === 'not required' || v === 'not applicable') return true;
    if (/^no[\s\-]/.test(v)) return true;
    if (v === 'without' || v.startsWith('without ')) return true;
    return false;
  }

  function parseSelectOptionName(nameAttr) {
    var open = (nameAttr || '').indexOf('options[');
    if (open === -1) return '';
    var rest = nameAttr.slice(open + 'options['.length);
    var close = rest.indexOf(']');
    return close === -1 ? '' : rest.slice(0, close);
  }

  function optionNameFromLegend(leg) {
    if (!leg) return '';
    var clone = leg.cloneNode(true);
    var sw = clone.querySelector('.variant-option__swatch-value');
    if (sw) sw.remove();
    return String(clone.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isCustomFromPicker(picker) {
    var radios = picker.querySelectorAll(
      'fieldset input[type="radio"]:checked, fieldset input[type="radio"][data-current-checked="true"]'
    );
    for (var i = 0; i < radios.length; i++) {
      var el = radios[i];
      var val = String(el.value || '').trim();
      if (CUSTOM_RE.test(val)) return true;
      var fs = el.closest('fieldset');
      var leg = fs && fs.querySelector('legend');
      var optionName = optionNameFromLegend(leg);
      if (CUSTOM_RE.test(optionName) && !isOptOutCustomValue(val)) return true;
    }
    var selects = picker.querySelectorAll('select.variant-option__select');
    for (var j = 0; j < selects.length; j++) {
      var sel = selects[j];
      var opt = sel.options[sel.selectedIndex];
      var val = opt && opt.value ? String(opt.value).trim() : '';
      if (CUSTOM_RE.test(val)) return true;
      var optName = parseSelectOptionName(sel.getAttribute('name') || '');
      if (CUSTOM_RE.test(optName) && !isOptOutCustomValue(val)) return true;
    }
    return false;
  }

  function getFormScope(form) {
    if (!form) return null;
    return (
      form.closest('.shopify-section') ||
      form.closest('quick-add-dialog') ||
      form.closest('#quick-add-modal-content') ||
      form.closest('product-form-component')?.parentElement ||
      form.closest('#MainContent')
    );
  }

  function findProductFormComponent(productId, form) {
    var modal = document.getElementById('quick-add-modal-content');
    if (modal && productId) {
      var inModal = modal.querySelector('product-form-component[data-product-id="' + productId + '"]');
      if (inModal) return inModal;
    }
    if (form) {
      var fromForm = form.closest('product-form-component');
      if (fromForm) return fromForm;
    }
    if (!productId) return null;
    return document.querySelector('product-form-component[data-product-id="' + productId + '"]');
  }

  function findPickerForForm(form, scope) {
    scope = scope || getFormScope(form);
    if (scope) {
      var inScope = scope.querySelector('variant-picker');
      if (inScope) return inScope;
    }
    var pf = form && form.closest('product-form-component');
    var pid = pf && pf.getAttribute('data-product-id');
    if (pid) {
      var byId = document.querySelector('variant-picker[data-product-id="' + pid + '"]');
      if (byId) return byId;
    }
    var main = document.getElementById('MainContent');
    return (main && main.querySelector('variant-picker')) || document.querySelector('variant-picker');
  }

  function isCustomSelection(scope, form) {
    var picker = findPickerForForm(form, scope);
    if (picker) return isCustomFromPicker(picker);
    var pf = form && form.closest('product-form-component');
    var only = pf && pf.getAttribute('data-only-variant-title');
    return !!(only && CUSTOM_RE.test(String(only).trim()));
  }

  function hasLineItemText(form) {
    var props = form.querySelectorAll(
      'textarea[name^="properties["], input[type="text"][name^="properties["]'
    );
    for (var i = 0; i < props.length; i++) {
      var el = props[i];
      if (el.type === 'hidden') continue;
      if (!el.name || el.name.indexOf('_ctc_quote_only') !== -1) continue;
      if (el.closest('[hidden]')) continue;
      if (el.value && String(el.value).trim()) return true;
    }
    var boxes = form.querySelectorAll('input[type="checkbox"][name^="properties["]:checked');
    return boxes.length > 0;
  }

  function hasUploadedFiles(form) {
    var hidden = form.querySelector('[data-ctc-files-prop]');
    return !!(hidden && String(hidden.value).trim());
  }

  function hasCustomExtras(form) {
    return hasLineItemText(form) || hasUploadedFiles(form);
  }

  /** Legacy hook — custom extras are encouraged, not required. */
  window.ctcValidateCustomVariantExtras = function () {
    return { ok: true };
  };

  function updateCustomEncourageNotice(form, productFormHost) {
    if (!form || !productFormHost) return;
    var banner =
      form.querySelector('[data-ctc-custom-encourage-msg]') ||
      form.querySelector('[data-ctc-custom-required-msg]');
    if (!banner) return;

    var scope = getFormScope(form);
    var custom = isCustomSelection(scope, form);

    if (!custom) {
      banner.hidden = true;
      return;
    }

    banner.hidden = !!hasCustomExtras(form);
  }

  function applyInlineCheckoutHide(root, hide) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(checkoutSelectors).forEach(function (el) {
      if (hide) {
        el.setAttribute('data-ctc-checkout-suppressed', '1');
        el.style.setProperty('display', 'none', 'important');
        el.setAttribute('hidden', '');
      } else if (el.getAttribute('data-ctc-checkout-suppressed') === '1') {
        el.removeAttribute('data-ctc-checkout-suppressed');
        el.style.removeProperty('display');
        el.removeAttribute('hidden');
      }
    });
  }

  function applySectionCheckoutSuppress(form, productFormHost) {
    var scope = getFormScope(form);
    if (!scope) return;

    var serverQuote = productFormHost.getAttribute('data-ctc-server-quote') === 'true';
    var custom = !serverQuote && isCustomSelection(scope, form);

    if (serverQuote || custom) {
      scope.setAttribute('data-ctc-suppress-dynamic-checkout', 'true');
      applyInlineCheckoutHide(scope, true);
    } else {
      scope.removeAttribute('data-ctc-suppress-dynamic-checkout');
      applyInlineCheckoutHide(scope, false);
    }
  }

  function clearLegacyMainCheckoutSuppress() {
    var mainEl = document.getElementById('MainContent');
    if (!mainEl) return;
    if (!mainEl.hasAttribute('data-ctc-suppress-dynamic-checkout')) return;
    mainEl.removeAttribute('data-ctc-suppress-dynamic-checkout');
    applyInlineCheckoutHide(mainEl, false);
  }

  function getOptionRows(picker) {
    return Array.prototype.slice.call(
      picker.querySelectorAll('fieldset.variant-option, .variant-option--dropdowns')
    );
  }

  function getRowValue(row) {
    var checked = row.querySelector('input[type="radio"]:checked');
    if (checked) return String(checked.value || '').trim();
    var sel = row.querySelector('select.variant-option__select');
    if (!sel) return '';
    var opt = sel.options[sel.selectedIndex];
    return opt && opt.value ? String(opt.value).trim() : '';
  }

  function hideOptionsAfterCustomInPicker(picker) {
    if (!picker) return;
    var rows = getOptionRows(picker);
    var hideAfter = false;
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var managed = row.getAttribute('data-ctc-managed-hidden');
      if (hideAfter) {
        row.setAttribute('data-ctc-managed-hidden', 'after-custom');
        row.hidden = true;
        row.setAttribute('aria-hidden', 'true');
      } else {
        if (managed === 'after-custom') {
          row.removeAttribute('data-ctc-managed-hidden');
          row.hidden = false;
          row.setAttribute('aria-hidden', 'false');
        }
        if (CUSTOM_RE.test(getRowValue(row))) hideAfter = true;
      }
    }
  }

  function hideOptionsAfterCustomInScope(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('variant-picker').forEach(hideOptionsAfterCustomInPicker);
  }

  function syncCustomVariantUi(form, productFormHost) {
    if (!form || !productFormHost) return;
    applySectionCheckoutSuppress(form, productFormHost);
    updateCustomEncourageNotice(form, productFormHost);
    hideOptionsAfterCustomInScope(getFormScope(form) || productFormHost);
  }

  var customEncourageListenersBound = false;
  function bindCustomEncourageFieldListeners() {
    if (customEncourageListenersBound) return;
    customEncourageListenersBound = true;

    document.addEventListener(
      'input',
      function (e) {
        var t = e.target;
        if (!(t instanceof HTMLElement)) return;
        if (!t.matches('textarea[name^="properties["], input[type="text"][name^="properties["]')) return;
        var form = t.closest('form[data-type="add-to-cart-form"]');
        if (!form) return;
        var pfc = form.closest('product-form-component');
        if (pfc) updateCustomEncourageNotice(form, pfc);
      },
      true
    );

    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!(t instanceof HTMLInputElement)) return;
        if (t.type !== 'checkbox' || !t.name || t.name.indexOf('properties[') !== 0) return;
        var form = t.closest('form[data-type="add-to-cart-form"]');
        if (!form) return;
        var pfc = form.closest('product-form-component');
        if (pfc) updateCustomEncourageNotice(form, pfc);
      },
      true
    );

    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!(t instanceof HTMLInputElement)) return;
        if (t.type !== 'file' || !t.classList.contains('ctc-file-input')) return;
        var form = t.closest('form[data-type="add-to-cart-form"]');
        if (!form) return;
        var pfc = form.closest('product-form-component');
        if (pfc) {
          window.requestAnimationFrame(function () {
            updateCustomEncourageNotice(form, pfc);
          });
        }
      },
      true
    );

    document.addEventListener('ctc:attached-files-changed', function (e) {
      var target = e.target;
      var form =
        target instanceof HTMLFormElement
          ? target
          : target && target.closest
            ? target.closest('form[data-type="add-to-cart-form"]')
            : null;
      if (!form) return;
      var pfc = form.closest('product-form-component');
      if (pfc) updateCustomEncourageNotice(form, pfc);
    });
  }

  function scheduleSyncFromEvent(e) {
    var pid = e.detail && e.detail.data && e.detail.data.productId;
    if (!pid) return;
    window.requestAnimationFrame(function () {
      var pfc = findProductFormComponent(pid);
      if (!pfc) return;
      var form = pfc.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;
      syncCustomVariantUi(form, pfc);
    });
  }

  window.ctcSyncCustomVariantUi = syncCustomVariantUi;

  window.ctcSyncCustomVariantUiInScope = function (scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('product-form-component').forEach(function (pfc) {
      var form = pfc.querySelector('form[data-type="add-to-cart-form"]');
      if (form) syncCustomVariantUi(form, pfc);
    });
  };

  document.addEventListener('variant:update', scheduleSyncFromEvent);
  document.addEventListener('variant:selected', function () {
    window.requestAnimationFrame(function () {
      hideOptionsAfterCustomInScope(document);
      document.querySelectorAll('product-form-component').forEach(function (pfc) {
        var form = pfc.querySelector('form[data-type="add-to-cart-form"]');
        if (form) syncCustomVariantUi(form, pfc);
      });
    });
  });
  document.addEventListener('ctc:custom-option-selected', function () {
    window.requestAnimationFrame(function () {
      var modal = document.getElementById('quick-add-modal-content');
      if (modal) window.ctcSyncCustomVariantUiInScope(modal);
    });
  });

  function initCustomVariantOnLoad() {
    bindCustomEncourageFieldListeners();
    clearLegacyMainCheckoutSuppress();
    hideOptionsAfterCustomInScope(document);
    document.querySelectorAll('product-form-component').forEach(function (pfc) {
      var form = pfc.querySelector('form[data-type="add-to-cart-form"]');
      if (form) syncCustomVariantUi(form, pfc);
    });
  }

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!(t instanceof HTMLElement)) return;
      if (!t.matches('fieldset.variant-option input[type="radio"], select.variant-option__select')) return;
      var picker = t.closest('variant-picker');
      if (!picker) return;
      hideOptionsAfterCustomInPicker(picker);
      var pfc = findProductFormComponent(picker.getAttribute('data-product-id'));
      if (!pfc) return;
      var form = pfc.querySelector('form[data-type="add-to-cart-form"]');
      if (form) syncCustomVariantUi(form, pfc);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomVariantOnLoad);
  } else {
    initCustomVariantOnLoad();
  }
})();
